export interface LocalMedia {

    /**
     * The reference identifying this media; this is what a selection carries and sends
     * back to the server (see {@code LocalMediaReference} on the server side).
     */
    mediaReference: string;

    name: string;
    contentType: string;
    documentMetadataCategoryId: number;
    description: string;
}

/** Separator between a supplier prefix and its token, mirroring {@code LocalMediaReference.SEPARATOR}. */
const MEDIA_REFERENCE_SEPARATOR = ':';

/** Pattern every supplier prefix has to match, mirroring {@code LocalMediaReference.PREFIX_PATTERN}. */
const MEDIA_REFERENCE_PREFIX_PATTERN = /^[a-zA-Z][a-zA-Z0-9_-]*$/;

/**
 * Derives the document-metadata obj guid a media reference stands for, mirroring the server
 * {@code LocalMediaReference.parse(...).documentMetadataObjGuid()}: a reference without a valid
 * supplier prefix <em>is</em> the obj guid, while a prefixed reference points at media that
 * is not backed by document metadata and therefore has none.
 *
 * @param mediaReference the reference to derive the obj guid from
 * @returns the obj guid, or {@code null} when the reference is not backed by document metadata
 */
export function documentMetadataObjGuidOf( mediaReference: string | null | undefined ): string | null {
    if ( mediaReference == null ) {
        return null;
    }

    const separatorIndex = mediaReference.indexOf( MEDIA_REFERENCE_SEPARATOR );
    if ( separatorIndex < 0 ) {
        return mediaReference;
    }

    const prefix = mediaReference.slice( 0, separatorIndex ).trim();
    const token = mediaReference.slice( separatorIndex + 1 ).trim();
    if ( prefix === '' || token === '' || !MEDIA_REFERENCE_PREFIX_PATTERN.test( prefix ) ) {
        return mediaReference;
    }

    return null;
}
